import React, { useEffect, useRef, useState } from 'react'
import Stores from 'Stores'
import styles from './QuestionAudios.module.scss'
import Plyr from 'plyr'
import { ReactComponent as ShowScript } from 'components/UI/icons/file-list-2-line.svg'
import useLocalization from 'hooks/useLocalization'
import LocalStorage from 'services/LocalStorage'

export function AudioPlayer(props) {
  const [show, setShow] = useState(null)
  const audioRef = useRef()
  const { innerWidth } = window
  const isMobile = innerWidth < 768
  const [player, setPlayer] = useState(null)

  const data = LocalStorage.get('ud')
  const lang = (data?.user_data.profile.localization || 'en').toLowerCase()

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'exercises',
    dict: {
      script: 'Script',
    },
  })

  const settings = {
    controls: isMobile
      ? ['play', 'progress', 'current-time', 'mute', 'settings']
      : ['play', 'progress', 'current-time', 'mute', 'volume', 'settings'],
    i18n: {
      speed: lang === 'ru' ? 'Скорость' : lang === 'kz' ? 'Жылдамдық' : 'Speed',
      normal: lang === 'ru' ? 'Обычная' : lang === 'kz' ? 'Тұрақты' : 'Normal',
    },
  }

  useEffect(() => {
    const newPlayer = new Plyr(audioRef.current, settings)
    setPlayer(newPlayer)

    return () => {
      newPlayer.destroy()
    }
  }, [isMobile])

  useEffect(() => {
    if (player) {
      player.on('play', () => {
        props.onPlay(props.index)
      })
    }
  }, [player, props])

  useEffect(() => {
    if (player && props.index !== props.activeIndex) {
      player.pause()
    }
  }, [player, props.index, props.activeIndex])

  return (
    <>
      <div className={styles.container}>
        <h4 className={styles.desc}>{props.description}</h4>
        <div className={styles.audioContainer}>
          <div className={styles.audio}>
            <audio ref={audioRef} controls>
              <source src={Stores.baseLink() + props.file} />
              Ваш браузер не поддерживает элемент <code>audio</code>.
            </audio>
          </div>
          <div
            className={styles.showScriptBtn}
            onMouseOver={() => setShow(props.index)}
            onMouseOut={() => setShow(null)}
          >
            <ShowScript />
            {show === props.index && (
              <div className={styles.scriptBody}>
                <p>{translate.script}</p>
                <p>{props.data}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default function QuestionAudios(props) {
  const [activeIndex, setActiveIndex] = useState(null)

  const handlePlay = (index) => {
    setActiveIndex(index)
  }

  return (
    <div className={styles.content}>
      {props.items.map((audio, index) => {
        return (
          <AudioPlayer
            key={index}
            index={index}
            file={audio.file}
            description={audio.description}
            onPlay={handlePlay}
            data={audio.data}
            activeIndex={activeIndex}
          />
        )
      })}
    </div>
  )
}
